import * as _ from 'underscore';
import { IInitialValue } from 'mappMvc/interfaces';
import { IValidationResult, IStringObject } from 'mappClient/models';
import { LegendClient, DesktopClientContentClient, ContentClient } from 'mappClient/clients';
import { isValidName } from 'mappMvc/extensions/ko';
import { Localization } from 'mappMvc/compile';

interface KnockoutValidationRuleDefinitions {
	isUniqueAsync: KnockoutValidationAsyncRuleDefinition;
	isValidLegend: KnockoutValidationAsyncRuleDefinition;
	isValidOverview: KnockoutValidationAsyncRuleDefinition;
	isValidCrs: KnockoutValidationAsyncRuleDefinition;
	isValidCustomCrs: KnockoutValidationAsyncRuleDefinition;
	isValidCustomWkt: KnockoutValidationAsyncRuleDefinition;
}

export interface IIsUniqueAsyncParams<T> extends IInitialValue<T> {
	ajax: (value: T) => Promise<IValidationResult>;
	isStringObject?: boolean;
}

export function registerValidation() {
	(function(ko: KnockoutStatic) {
		ko.validation.rules.isUniqueAsync = {
			async: true,
			validator: function(
				value: string,
				params: IIsUniqueAsyncParams<any>,
				callback: (any) => any
			) {
				let initialValue = params.isStringObject
					? ko.utils.unwrapObservable(params.initialValue).value
					: ko.utils.unwrapObservable(params.initialValue);

				if (value && value != initialValue) {
					let postValue = params.isStringObject
						? <IStringObject>{
								value: value
						  }
						: value;

					params
						.ajax(postValue)
						.then(callback)
						.catch(() =>
							callback({
								isValid: false,
								message: Localization.Errors.NoValidationServer
							})
						);
				} else {
					callback(true);
				}
			},
			message: Localization.Errors.NoValidationServer
		};

		ko.validation.rules.isValidLegend = {
			async: true,
			validator: function(name: string, params, callback: (any) => any) {
				if (name) {
					if (isValidName(name)) {
						LegendClient.isValidLegend(name).then(callback, () =>
							callback({
								isValid: false,
								message: Localization.Errors.NoValidationServer
							})
						);
					} else {
						callback({
							isValid: false,
							message: Localization.Validation.isValidName
						});
					}
				} else {
					callback(true);
				}
			},
			message: Localization.Validation.isValidName
		};

		ko.validation.rules.isValidOverview = {
			async: true,
			validator: function(name: string, params, callback: (any) => any) {
				if (name) {
					if (isValidName(name)) {
						DesktopClientContentClient.isValidOverview(name).then(callback, () =>
							callback({
								isValid: false,
								message: Localization.Errors.NoValidationServer
							})
						);
					} else {
						callback({
							isValid: false,
							message: Localization.Validation.isValidName
						});
					}
				} else {
					callback(true);
				}
			},
			message: Localization.Validation.isValidName
		};

		ko.validation.rules.isValidCrs = {
			async: true,
			validator: function(srid: number, params: any, callback: (any) => any) {
				if (srid) {
					let validCrsPromise =
						_.isObject(params) && params.onlyProjected
							? ContentClient.isValidProjectedCrs
							: ContentClient.isValidCrs;

					validCrsPromise(srid).then(callback, () =>
						callback({
							isValid: false,
							message: Localization.Errors.NoValidationServer
						})
					);
				} else {
					callback(true);
				}
			},
			message: Localization.Errors.NoValidationServer
		};

		ko.validation.rules.isValidCustomCrs = {
			async: true,
			validator: function(srid: number, params, callback: (any) => any) {
				if (srid) {
					ContentClient.isCustomCrsValid(srid).then(callback, () =>
						callback({
							isValid: false,
							message: Localization.Errors.NoValidationServer
						})
					);
				} else {
					callback(true);
				}
			},
			message: Localization.Errors.NoValidationServer
		};

		ko.validation.rules.isValidCustomWkt = {
			async: true,
			validator: function(wkt: string, params, callback: (any) => any) {
				if (wkt) {
					ContentClient.isCustomWktValid(<IStringObject>{
						value: wkt
					}).then(callback, () =>
						callback({
							isValid: false,
							message: Localization.Errors.NoValidationServer
						})
					);
				} else {
					callback(true);
				}
			},
			message: Localization.Errors.NoValidationServer
		};

		ko.validation.registerExtenders();
	})(ko);
}
